const SECONDS_LEFT_OFFSET = 13;

export const getSecondsLeftFromMessage = (message: string): number => {
  const substr = message.substring(
    message.search('secondsLeft') + SECONDS_LEFT_OFFSET,
    message.length
  );

  return Math.ceil(+substr);
};
